import { SwalMessage, ToastMessage } from '../../Tools'


// initial
var Order = function () {

    // fatura görüntüleme
    $(document).on('click', '[data-invoice-show]', function (event) {
        event.preventDefault();

        let orderNumber = this.getAttribute('data-order-number')

        let modal = document.querySelector('#invoice-show')


        let iframe = modal.querySelector('iframe')

        iframe.setAttribute('src', apiUrl + '/OrderInvoiceShow/' + orderNumber)

    })

    // sipariş iptal/iade
    $(document).on('click', '[data-order-cancelled-submit]', function (event) {
        event.preventDefault();

        let orderNumber = this.getAttribute('data-order-number')
        let modal = event.target.closest('.modal')
        let customerNote = modal.querySelector('#customer_note').value

        $.ajax({
            url: apiUrl + '/OrderClaimCreated',
            type: "POST",
            dataType: "json",
            data: {
                orderNumber: orderNumber,
                customerNote: customerNote
            },
            error: function error(xhr) {
                //console.log(xhr)
                SwalMessage(
                    {
                        type: 'error',
                        text: xhr.responseJSON.text ?? xhr.responseJSON.message,
                        confirmButton: translate.ok_button,
                    },
                    function () {
                        // location.reload();
                    }
                );
            },
            success: function success(xhr) {
                SwalMessage(
                    {
                        type: 'success',
                        text: xhr.text ?? xhr.message,
                        confirmButton: translate.ok_button,
                    },
                    function () {
                        location.reload();
                    }
                );
            }
        });

    });

    var handle = function () {

    }

    return {
        init: function () {
            handle();
        },
    };

}();


$(function () {
    Order.init();
});